import { vacationService } from '@services/index';
import { useQuery } from '@tanstack/react-query';

export default function useQueryVacations() {
	return useQuery({
		queryKey: ['Vacations'],
		queryFn: () => vacationService.getVacations()
		// enabled: true,
	});
}
